import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {FIELD_ORDER_UI_SCHEMA_KEY, NUM_COLUMNS_KEY, StepConfigEditorOverride} from '../StepConfigEditorTypes';

export const CREATE_METERING_USAGE_CHART_V0_UI_SCHEMA: StepTypeConfigUISchemaV2<
  PipelineStepType.CREATE_METERING_USAGE_CHART,
  0
> = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['dateRange', 'productType', 'userId'],
  [NUM_COLUMNS_KEY]: 3,
  dateRange: {
    displayName: 'Date range',
    configShapePath: ['dateRange'],
    editorOverride: StepConfigEditorOverride.DATE_RANGE,
    fieldSettings: {
      startKey: 'startDate',
      endKey: 'endDate',
    },
  },
  productType: {
    displayName: 'Product',
    configShapePath: ['productType'],
    fieldSettings: {
      displayNames: {
        AI_ASK: 'Ask',
        CHAT: 'Chat',
        COMPOSE: 'Compose',
        DATA_ENTRY_AGENT: 'Data Entry',
        DEEP_RESEARCH: 'Deep Research',
        STRUCTURE_PREDICTION: 'Structure Prediction',
      },
    },
  },
  userId: {
    displayName: 'User',
    configShapePath: ['userId'],
    fieldSettings: {
      serviceAccountAgentsOnly: true,
    },
  },
};
